/* eslint-disable */
import React from "react";
import { Menu, Tooltip } from "@mantine/core";
import { useHasPermission } from "./useHasPermission";

type PermissionMenuItemProps = {
  permission: string;
  hideIfNo?: boolean;
  tooltipIfNo?: string;
  icon?: React.ReactNode;
  color?: any;
  onClick?: (e?: React.MouseEvent) => void;
  children?: React.ReactNode;
};

const PermissionMenuItem: React.FC<PermissionMenuItemProps> = ({
  permission,
  hideIfNo = false,
  tooltipIfNo = "You don't have permission",
  icon,
  color,
  onClick,
  children,
}) => {
  const { has, isLoading } = useHasPermission(permission);

  if (isLoading) {
    return (
      <Menu.Item icon={icon} disabled color={color}>
        {children}
      </Menu.Item>
    );
  }

  if (!has) {
    if (hideIfNo) return null;

    return (
      <Tooltip label={tooltipIfNo} withArrow>
        <div style={{ display: "block" }}>
          <Menu.Item icon={icon} disabled color={color}>
            {children}
          </Menu.Item>
        </div>
      </Tooltip>
    );
  }

  return (
    <Menu.Item icon={icon} onClick={onClick} color={color}>
      {children}
    </Menu.Item>
  );
};

export default PermissionMenuItem;
